<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${heroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">SAWARIYA FASHION</div>
          <div class="hero-desc">
            Discover trendy t-shirts, stylish shirts, comfortable jeans, and fun clothing sets for boys. From playful everyday wear to festive ethnic outfits — quality fashion for every little adventurer.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <div>
            <h2>New Arrivals</h2>
            <p>Fresh styles added every week</p>
          </div>
          <div class="section-header-right">
            <router-link class="section-cta" to="/goods">Shop Now</router-link>
          </div>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹599 across India</p>
          </div>
          <div class="why-item">
            <div class="why-icon">✨</div>
            <h3>Premium Quality</h3>
            <p>Durable, comfortable fabrics built for active boys</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free return & exchange</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payments</h3>
            <p>UPI, COD & card payments accepted</p>
          </div>
        </div>

        <!-- Farm Fresh Fruits Section -->
        <div class="home-section fruit-home-section">
          <div class="home-section-header">
            <div>
              <h2>🍎 Farm Fresh Fruits</h2>
              <p>Farm-direct, cold-chain delivered — 0% GST</p>
            </div>
            <div class="section-tabs-wrap">
              <router-link class="section-cta fruit-cta" to="/goods?categoryID=201">Shop All Fruits →</router-link>
            </div>
          </div>
          <div class="fruit-grid">
            <router-link
              v-for="fruit in fruitProducts"
              :key="fruit.id"
              :to="fruit._link"
              class="fruit-card"
            >
              <div class="fruit-card-img">
                <img :src="fruit.img" :alt="fruit.name" loading="lazy" />
                <span class="fruit-tag">{{ fruit.tag }}</span>
              </div>
              <div class="fruit-card-body">
                <h3>{{ fruit.name }}</h3>
                <p class="fruit-pack">{{ fruit.packSize }}</p>
                <p class="fruit-price">₹{{ fruit.price }}</p>
              </div>
            </router-link>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Bestsellers</h2>
              <p>Top picks loved by our customers</p>
            </div>
            <div class="section-tabs-wrap">
              <div class="section-tabs">
                <span class="tab-item" :class="{active: discoverActive===71}" @click="discoverActive=71">T-SHIRTS</span>
                <span class="tab-item" :class="{active: discoverActive===72}" @click="discoverActive=72">SHIRTS</span>
                <span class="tab-item" :class="{active: discoverActive===75}" @click="discoverActive=75">CLOTHING SETS</span>
              </div>
              <router-link class="section-cta" to="/goods">View All</router-link>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Offer</span>
            <h2>KIDS FASHION SALE</h2>
            <p>Up to 40% Off on Boys' Clothing</p>
            <router-link class="promo-btn" to="/goods">Shop Deals</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/36753890/img_00.jpg" alt="Sale" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Summer Collection</div>
              <div class="split-desc">
                Cool t-shirts and shorts for sunny days — playful prints and comfy fits
              </div>
              <router-link class="section-cta" to="/goods">Shop Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40305430/img_00.jpg" alt="Ethnic" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Casual Shirts</div>
              <div class="split-desc">
                Smart-casual shirts for school and outings — style meets comfort
              </div>
              <router-link class="section-cta" to="/goods">Shop Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/36982162/img_03.jpg" alt="Casual" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as rankingAPI from '@/api/ranking/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据
      phonesList: [], // 手机商品列表
      televisionsList: [], // 小米电视商品列表
      applianceList: [], // 家电商品列表
      applianceHotList: [], //热门家电商品列表
      accessoryList: [], //配件商品列表
      accessoryHotList: [], //热门配件商品列表
      phoneShellsList: [], // 保护套商品列表
      chargersList: [], //充电器商品列表
      applianceActive: 1, // 家电当前选中的商品分类
      accessoryActive: 1, // 配件当前选中的商品分类
      discoverActive: 71, // Discover section active tab (T-SHIRTS=71, SHIRTS=72, SETS=75)
      kurtasList: [],
      tshirtsList: [],
      blazersList: [],
      fruitList: [],
      fruitStart: 0,
      fruitLimit: 6,
      start: 0,
      limit: 4,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    heroImage() {
      if (this.carousels && this.carousels.length) {
        return this.carousels[0].img_path
      }
      return 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41487626/img_02.jpg'
    },
    discoverProducts() {
      if (this.discoverActive === 71) return this.kurtasList
      if (this.discoverActive === 72) return this.tshirtsList
      return this.blazersList
    },
    fruitProducts() {
      const OSS = 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5'
      // Use API data if available, otherwise static OSS fallback
      if (this.fruitList && this.fruitList.length > 0) {
        return this.fruitList.slice(0, 6).map(p => ({
          id: p.id,
          name: p.name,
          img: p.img_path,
          price: p.discount_price || p.price,
          tag: this.extractFruitTag(p.properties),
          packSize: this.extractFruitPack(p.properties),
          _link: { path: '/goods/details', query: { productID: p.id } }
        }))
      }
      // Static fallback with OSS fruit images
      return [
        { id: 'f1', name: 'Alphonso Mango', img: OSS + '/AP4-001/AP4-001.jpg', price: '100', tag: 'PREMIUM', packSize: '1 kg', _link: '/goods?categoryID=201' },
        { id: 'f2', name: 'Nagpur Orange', img: OSS + '/AP4-011/AP4-011.jpg', price: '200', tag: 'NEW', packSize: 'Dozen', _link: '/goods?categoryID=202' },
        { id: 'f3', name: 'Strawberry', img: OSS + '/AP4-021/AP4-021.jpg', price: '300', tag: 'COLD CHAIN', packSize: '500 g', _link: '/goods?categoryID=203' },
        { id: 'f4', name: 'Sweet Cherry', img: OSS + '/AP4-034/AP4-034.jpg', price: '1500', tag: 'BEST SELLER', packSize: 'Premium box', _link: '/goods?categoryID=204' },
        { id: 'f5', name: 'Watermelon Kiran', img: OSS + '/AP4-041/AP4-041.jpg', price: '500', tag: 'PREMIUM', packSize: 'Premium box', _link: '/goods?categoryID=205' },
        { id: 'f6', name: 'Kiwi Green', img: OSS + '/AP4-051/AP4-051.jpg', price: '1000', tag: 'NEW', packSize: '2 kg', _link: '/goods?categoryID=206' }
      ]
    }
  },
  watch: {
    // 家电当前选中的商品分类，响应不同的商品数据
    applianceActive: function(val) {
      // 页面初始化的时候把applianceHotList(热门家电商品列表)直接赋值给applianceList(家电商品列表)
      // 所以在切换商品列表时判断applianceHotList是否为空,为空则是第一次切换,把applianceList赋值给applianceHotList
      if (this.applianceHotList == '') {
        this.applianceHotList = this.televisionsList
      }
      if (val == 1) {
        // 1为热门商品
        this.applianceList = this.applianceHotList
        return
      }
      if (val == 2) {
        // 2为电视商品
        this.applianceList = this.televisionsList
        return
      }
    },
    accessoryActive: function(val) {
      // 页面初始化的时候把accessoryHotList(热门配件商品列表)直接赋值给accessoryList(配件商品列表)
      // 所以在切换商品列表时判断accessoryHotList是否为空,为空则是第一次切换,把accessoryList赋值给accessoryHotList
      if (this.accessoryHotList == '') {
        this.accessoryHotList = this.chargersList
      }
      if (val == 3) {
        // 1为热门商品
        this.accessoryList = this.accessoryHotList
        return
      }
      if (val == 2) {
        // 2为保护套商品
        this.accessoryList = this.phoneShellsList
        return
      }
      if (val == 1) {
        //3 为充电器商品
        this.accessoryList = this.chargersList
        return
      }
    }
  },
  activated() {
    // 获取首页数据
    this.load()
  },
  methods: {
    load() {
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) {
            this.carousels = res.data
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
            
            // Find categories for Discover section
            this.getProduct(71, 'kurtasList')  // T-Shirts
            this.getProduct(72, 'tshirtsList')  // Shirts
            this.getProduct(75, 'blazersList')  // Clothing Sets
            // Fetch fruit products (Tropical Fruits = 201)
            this.getProduct(201, 'fruitList')
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      //获取热门家电
      rankingAPI
        .listElecRanking()
        .then(res => {
          if (res.status === 200) {
            this.applianceHotList = res.data
            this.applianceList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取热门配件
      rankingAPI
        .listAcceRanking()
        .then(res => {
          if (res.status === 200) {
            this.accessoryHotList = res.data
            this.accessoryList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取女性民族服饰列表
      this.getProduct(71, 'chargersList')  // T-Shirts

      this.getProduct(72, 'phonesList')  // Shirts
      //获取童装套装列表
      this.getProduct(75, 'televisionsList')  // Clothing Sets
      //获取牛仔裤列表
      this.getProduct(73, 'phoneShellsList')  // Jeans
    },
    // Find categories for Discover section
    findDiscoverCategories() {
      // Boys' clothing category IDs
      this.getProduct(71, 'kurtasList')  // T-Shirts
      this.getProduct(72, 'tshirtsList')  // Shirts
      this.getProduct(75, 'blazersList')  // Clothing Sets
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data.items) ? res.data.items : []
            // Shuffle the product list
            this.homeProducts = this.shuffleArray(list)
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle algorithm
    shuffleArray(array) {
      const shuffled = [...array]
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
      }
      return shuffled
    },
    // 获取家电模块子组件传过来的数据
    getChildMsg(val) {
      this.applianceActive = val
    },
    // 获取配件模块子组件传过来的数据
    getChildMsg2(val) {
      this.accessoryActive = val
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = res.data.items
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    extractFruitTag(properties) {
      try {
        const p = typeof properties === 'string' ? JSON.parse(properties) : properties
        return (p && p.Tag) ? p.Tag : ''
      } catch { return '' }
    },
    extractFruitPack(properties) {
      try {
        const p = typeof properties === 'string' ? JSON.parse(properties) : properties
        return (p && p['Pack Size']) ? p['Pack Size'] : ''
      } catch { return '' }
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F0FDF4')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F0FDF4')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>
